module.exports = __webpack_public_path__ + "static/media/HomePic.930190d7.png";